/**
 * Device identity. One random token in localStorage *is* the player: it is what
 * lets a reload — or a phone that locked itself mid-deal — walk back into the
 * same seat with the same cards.
 */

const TOKEN_KEY = 'manille.device-token';
const NAME_KEY = 'manille.name';
const GAME_KEY = 'manille.last-game';

function randomToken(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export function deviceToken(): string {
  try {
    const existing = localStorage.getItem(TOKEN_KEY);
    if (existing && existing.length >= 8) return existing;
    const token = randomToken();
    localStorage.setItem(TOKEN_KEY, token);
    return token;
  } catch {
    // Private mode with storage blocked: the seat simply will not survive a
    // reload, which beats refusing to start.
    return randomToken();
  }
}

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

export function storedName(): string {
  return read(NAME_KEY) ?? '';
}

export function setStoredName(name: string): void {
  write(NAME_KEY, name.trim().slice(0, 16));
}

export function lastGameId(): string | null {
  return read(GAME_KEY);
}

export function setLastGameId(gameId: string): void {
  write(GAME_KEY, gameId);
}

/**
 * Forget the table we were at. Without this the app rejoins the stored game on
 * every launch and there is no way back to the home screen.
 */
export function clearLastGameId(): void {
  try {
    localStorage.removeItem(GAME_KEY);
  } catch {
    /* ignore */
  }
}
